import { useLayoutEffect } from "react";

import { useInfosecBannerData } from "./infosec-banner";
import { useItarBannerData } from "./itar-banner";

type TopBannerOffsetData = {
  infosecBannerOffset: number;
  itarBannerOffset: number;
  totalBannerOffset: number;
};

export function useTopBannerOffset(): TopBannerOffsetData {
  const { bannerOffset: infosecBannerOffset } = useInfosecBannerData();
  const { bannerOffset: itarBannerOffset } = useItarBannerData();
  const totalBannerOffset = infosecBannerOffset + itarBannerOffset;

  return { infosecBannerOffset, itarBannerOffset, totalBannerOffset };
}

export function TopBannerOffsetEffect() {
  const { totalBannerOffset } = useTopBannerOffset();

  useLayoutEffect(() => {
    // CSS variable name retained for back-compat with sidebar/app-layout consumers;
    // value now reflects the *combined* offset of all top banners.
    document.documentElement.style.setProperty("--infosec-banner-offset", `${totalBannerOffset}px`);
    return () => {
      document.documentElement.style.removeProperty("--infosec-banner-offset");
    };
  }, [totalBannerOffset]);

  return null;
}
